import { action, makeObservable, observable, computed, values, ObservableMap } from 'mobx';

import { Call } from '@gem/call/CallStore/Call';
import {
  IWaitingRoomMember,
  WaitingRoomMemberChangedStatus,
} from '@gem/call/Model/callModel.types';

export class CallWaitingRoom {
  call: Call;
  @observable requested = observable.map<string, IWaitingRoomMember>({}, { deep: false });
  @observable enabled = false;
  constructor(call: Call) {
    makeObservable(this);
    this.call = call;
  }

  @computed get requestedMembersArray(): readonly IWaitingRoomMember[] {
    return values(this.requested);
  }

  @action setRequested(requested: IWaitingRoomMember[]): void {
    this.requested = requested.reduce<ObservableMap>((acc, item) => {
      if (item.status === WaitingRoomMemberChangedStatus.Requested) {
        acc.set(item.memberId, item);
      }
      return acc;
    }, observable.map({}));
  }

  @action changeMemberStatus(member: IWaitingRoomMember): void {
    if (
      member.status === WaitingRoomMemberChangedStatus.Requested &&
      !this.requested.has(member.memberId)
    ) {
      this.requested.set(member.memberId, member);
    } else if (this.requested.has(member.memberId)) {
      this.requested.delete(member.memberId);
    }
  }

  @action setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }
}
